import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import VueNumericInput from 'vue-numeric-input'

export default {
    name: 'CompleteCart',
    computed,
    data,
    methods,
    mounted,
    components: {
        VueNumericInput
    }
}
